import { SharedDocumalisModule } from '@documalis/shared-documalis.module';
import { NgModule } from '@angular/core';
import { CustRightsRoutes } from './custrights.routes';
import { ListCustRightsComponent } from './list-custrights/list-custrights.component';
import { FormCustRightsComponent } from './_components/form-custrights/form-custrights.component';
import { AddCustRightsComponent } from './add-custrights/add-custrights.component';
import { EditCustRightsComponent } from './edit-custrights/edit-custrights.component';
import { TranslateModule } from '@ngx-translate/core';
import { InputSwitchModule } from 'primeng/inputswitch';

@NgModule({
    imports: [CustRightsRoutes, SharedDocumalisModule,TranslateModule, InputSwitchModule],
    declarations: [ListCustRightsComponent, AddCustRightsComponent, EditCustRightsComponent, FormCustRightsComponent],
})
export class CustRightsModule {}
